import { useCurrentUser } from '@framework/auth';
import {
  IModuleStateMachineRecord,
  ModuleStateMachine,
  SubmissionModuleState,
} from '@framework/frontoffice-submission';
import { useTranslation } from '@framework/i18n';
import React, { useMemo } from 'react';
import { SubmissionModuleSigner } from '../../sign/SubmissionModuleSigner';
import { ActionMessage } from './ActionMessage';

export interface ISIgnActionButtonsProps {
  data: IModuleStateMachineRecord;
}

export function SignActionButtons(props: ISIgnActionButtonsProps) {
  const { data } = props;

  const currentUser = useCurrentUser();
  const { t } = useTranslation();

  const canBeSigned = useMemo(() => {
    return ModuleStateMachine.canTransition(data, {
      from: SubmissionModuleState.Sign,
      to: SubmissionModuleState.Completed,
      user: currentUser,
    });
  }, [currentUser, data]);

  if (!canBeSigned.allowed && canBeSigned.message === 'no-action-permission') {
    return (
      <ActionMessage
        message={t(
          'submission-action-button.firma-delegata',
          'La firma è delegata ad un altro utente.',
        )}
        type="info"
      />
    );
  }

  if (!canBeSigned.allowed) return null;

  return (
    <SubmissionModuleSigner
      showTitle
      submission={data.submission}
      submissionModule={data.module}
    />
  );
}
